import FilterForm from 'assets/components/filters/filterForm/FilterForm';
import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';
import Icon from 'assets/components/icon/Icon';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import useApi from 'assets/hooks/api/useApi';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import Distributor from 'models/sales/distributor/Model.Distributor';
import { useLenderProvider } from '../Lender.Hooks';

export default function LenderFilters() {
  const { isDistributor, isDealer } = useAuthStore();
  const { lang } = getLocales();
  const { listApi } = useLenderProvider();
  const distributorsApi = useApi({ action: Distributor.list });

  return (
    <FilterForm
      subcomponents={ThemeFilterFormDrawer}
      search={listApi.body?.search}
      onSearch={(search) => listApi.execute((body) => ({ ...body, search, offset: 0 }))}
      onSortById={(sort) => listApi.execute((body) => ({ ...body, ...sort }))}
      filters={listApi.body}
      onFilter={(newFilers) => listApi.execute({ ...newFilers, offset: 0 })}
      onReset={listApi.reset}
      onOpen={() => {
        if (!distributorsApi.payload && !isDistributor && !isDealer) distributorsApi.execute();
      }}
      render={({ tempFilters, setFilters }) =>
        distributorsApi.payload?.data &&
        !isDistributor &&
        !isDealer && (
          <SelectInput
            name="distributorId"
            label={lang.distributors}
            data={distributorsApi.payload?.data?.map((item) => ({
              ...item.displayInfo,
              icon: <Icon class="fas-box" />,
            }))}
            isMultiselect
            value={tempFilters?.distributorId}
            onChange={({ distributorId }) => setFilters({ ...tempFilters, distributorId })}
            icon={<Icon class="fas-box" />}
          />
        )
      }
    />
  );
}
